const ROOT = "/hotels";

export const LODGING_FALLBACK = "*";
export const LODGING_AVAILABILITY_PATH = "/availability/:location/:placeId?";
export const LODGING_SHOP_PATH = "/shop/:lodgingName?/:id";
export const LODGING_BOOK_PATH = "/book";
export const LODGING_BOOK_FULL_PATH = ROOT + LODGING_BOOK_PATH;
export const LODGING_SEARCH_PATH = "/search";
export const LODGING_SEARCH_FULL_PATH = ROOT + LODGING_SEARCH_PATH;
